import { Directive, TemplateRef, inject } from '@angular/core';

/** Marker directive for a custom heading template within forma-text-icon-card. */
@Directive({
  selector: '[formaTextIconCardHeading]',
})
export class TextIconCardHeading {
  readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
}

/** Marker directive for a custom body template within forma-text-icon-card. */
@Directive({
  selector: '[formaTextIconCardBody]',
})
export class TextIconCardBody {
  readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
}

/** Marker directive for actions rendered beneath the text content. */
@Directive({
  selector: '[formaTextIconCardActions]',
})
export class TextIconCardActions {
  readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
}

/** Marker directive for a custom icon template within forma-text-icon-card. */
@Directive({
  selector: '[formaTextIconCardIcon]',
})
export class TextIconCardIcon {
  readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
}

/** Marker directive for content rendered in a second column next to the text content. */
@Directive({
  selector: '[formaTextIconCardAside]',
})
export class TextIconCardAside {
  readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
}
